import axios from 'axios';

import { validateUser } from 'utils/functions/authentication';

const request = {
  get(headers, url, params) {
    const configOptions = {
      params,
      headers,
      validateStatus(status) {
        return status <= 500;
      },
    };

    const apiCallPromis = axios.get(url, configOptions);
    return apiCallPromis;
  },

  post(headers, url, params, queryParams) {
    const configOptions = {
      headers,
      validateStatus(status) {
        return status <= 500;
      },
    };

    let updatedUrl = url;
    if (queryParams) {
      const queryArr = [];
      Object.keys(queryParams).forEach(queryKey => {
        queryArr.push(`${queryKey}=${queryParams[queryKey]}`);
      });
      const queryString = queryArr.join('&');
      updatedUrl = `${url}?${queryString}`;
    }

    const apiCallPromis = axios.post(updatedUrl, params, configOptions);
    return apiCallPromis;
  },

  put(headers, url, params) {
    const configOptions = {
      headers,
      validateStatus(status) {
        return status <= 500;
      },
    };

    const apiCallPromis = axios.put(url, params, configOptions);
    return apiCallPromis;
  },

  patch(headers, url, params) {
    const configOptions = {
      headers,
      validateStatus(status) {
        return status <= 500;
      },
    };

    const apiCallPromis = axios.patch(url, params, configOptions);
    return apiCallPromis;
  },

  delete(headers, url, data) {
    const configOptions = {
      data,
      headers,
      validateStatus(status) {
        return status <= 500;
      },
    };

    const apiCallPromis = axios.delete(url, configOptions);
    return apiCallPromis;
  },
};

const wrapAdmin =
  method =>
  // eslint-disable-next-line consistent-return
  async (customHeaders = {}, replaceHeaders = false, ...props) => {
    const { isValidUser, appToken } = await validateUser();

    if (isValidUser) {
      let headers = {
        authorization: `Bearer ${appToken}`,
        ...customHeaders,
      };
      if (replaceHeaders) headers = customHeaders;

      return request[method](headers, ...props);
    }

    document.location.href = '/login';
  };

const wrapAnonymous =
  method =>
  // eslint-disable-next-line consistent-return
  async (customHeaders = {}, replaceHeaders = false, ...props) => {
    let headers = {
      // you can add any global headers here
      ...customHeaders,
    };
    if (replaceHeaders) headers = customHeaders;

    return request[method](headers, ...props);
  };

export const adminRequests = {
  get: wrapAdmin('get'),
  post: wrapAdmin('post'),
  patch: wrapAdmin('patch'),
  delete: wrapAdmin('delete'),
};

export const anonymousRequests = {
  post: wrapAnonymous('post'),
  put: wrapAnonymous('put'),
};
